<template>
  <div class="app-empty-state">
    <span class="app-empty-state__icon">
      <AppIcon :name="icon" font-scale="1.6" weight="500" />
    </span>
    <div class="app-empty-state__title">{{ title }}</div>
    <div v-if="description" class="app-empty-state__description">{{ description }}</div>
  </div>
</template>

<script>
/**
 * Estado vacío estándar para listados y paneles ("no se encontraron
 * registros", "sin resultados para el filtro", etc.). Reemplaza los
 * <b-alert variant="warning"> de texto plano en las vistas migradas al
 * estándar de docs/list-view-interfaces/README.md.
 *
 * Registrado global en main.js como <EmptyState>, igual que AppIcon.
 * No usar para avisos de negocio (saldos, validaciones): eso sigue siendo
 * un b-alert semántico.
 */
export default {
  name: 'EmptyState',
  props: {
    icon: { type: String, default: 'search' },
    title: { type: String, required: true },
    description: { type: String, default: '' },
  },
}
</script>

<style scoped>
.app-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 28px 16px;
  border: 1px dashed var(--app-color-border-strong);
  border-radius: 9px;
  background: var(--app-color-surface-subtle);
  text-align: center;
}
.app-empty-state__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: var(--app-color-surface);
  border: 1px solid var(--app-color-border);
  color: var(--app-color-text-muted);
}
.app-empty-state__title {
  color: var(--app-color-text-secondary);
  font-size: var(--app-text-sm);
  font-weight: var(--app-font-semibold);
}
.app-empty-state__description {
  max-width: 420px;
  color: var(--app-color-text-muted);
  font-size: var(--app-text-xs);
  line-height: 1.4;
}
</style>
